// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"Layout_MainLayout__2DX-V","Layout":"Layout_Layout__1iVNg","Footer":"Layout_Footer__10e0Q"};